"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              show: true
            };
        },
        onShowNav: function() {
          this.state.show = !this.state.show;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Activity/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    StateNav_template = require("./components/StateNav.marko"),
    StateNav_tag = marko_loadTag(StateNav_template),
    ProgressNav_template = require("./components/ProgressNav.marko"),
    ProgressNav_tag = marko_loadTag(ProgressNav_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Card_Activity_template = require("../../../../../components/Card-Activity.marko"),
    Card_Activity_tag = marko_loadTag(Card_Activity_template),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_template = require("../../../../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "position-absolute left-0 top-0 d-inline-block theme-bg rounded-circle border pl-2 pr-25 py-1",
        style: "margin-top:50px;margin-left:-45px;z-index:100"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("b596d9"),
    marko_node0 = marko_createElement("div", {
        "class": "classroom-header"
      }, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "classroom-body pb-4 px-2"
      },
    marko_node1 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "row m-0"
      },
    marko_attrs3 = {
        "class": "col pr-3"
      },
    marko_node3 = marko_createElement("div", {
        "class": "position-relative mt-6"
      }, "18", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-unstyled users-list m-0 d-flex align-items-center"
        }, null, null, 4)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-20.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-22.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-12.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-21.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0),
    marko_node4 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "33", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("div", {
        "class": "position-relative mt-6"
      }, "36", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-unstyled users-list m-0 d-flex align-items-center"
        }, null, null, 7)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Alain Krich"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-15.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Berson Delano"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-25.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Xiona Peace"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-20.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Tchili Bertain"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-18.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Menlona Ivlaskiv"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-10.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Tolla Nkombi"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-23.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Mates",
              "data-container": "#A-switch",
              "data-class-id": "classID",
              "class": "center-align",
              title: "See All"
            }, null, null, 1)
            .e("i", {
                "class": "bx bx-dots-horizontal-rounded grey lighten-2 rounded-circle font-medium-5",
                style: "padding:10px;"
              }, null, null, 0),
    marko_node7 = marko_createElement("br", null, "59", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("br", null, "60", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        id: "activities",
        "class": "col"
      },
    marko_attrs5 = {
        "class": "mt-4"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        if (!state.show) {
          out.be("div", marko_attrs0, "1", component, null, 0, {
              onclick: __component.d("click", "onShowNav", false)
            });

          Bx_tag({
              type: "chevron-right",
              class: "font-large-1"
            }, out, __component, "2");

          out.ee();
        }

        Row_tag({
            class: "no-gutters",
            col: [
                {
                    class: (state.show ? "col-3" : "d-none") + " border-left border-right",
                    style: !state.show ? "width:0!important" : "",
                    renderBody: function(out) {
                      AutoScroll_tag({
                          height: "100vh",
                          class: "classroom-nav position-sticky top-0",
                          renderBody: function(out) {
                            StateNav_tag({}, out, __component, "6", [
                              [
                                "close",
                                "onShowNav",
                                false
                              ]
                            ]);

                            ProgressNav_tag({}, out, __component, "7");
                          }
                        }, out, __component, "5");
                    }
                  },
                {
                    class: "col p-0",
                    renderBody: function(out) {
                      out.n(marko_node0, component);

                      out.be("div", marko_attrs1, "10", component);

                      out.n(marko_node1, component);

                      out.n(marko_node2, component);

                      out.be("section", null, "13", component);

                      out.be("div", marko_attrs2, "14", component);

                      out.be("div", marko_attrs3, "15", component);

                      out.be("h6", null, "16", component);

                      Locale_tag({
                          text: "Intructors"
                        }, out, __component, "17");

                      out.ee();

                      out.n(marko_node3, component);

                      out.n(marko_node4, component);

                      out.n(marko_node5, component);

                      out.be("h6", null, "34", component);

                      Locale_tag({
                          text: "Classmates"
                        }, out, __component, "35");

                      out.ee();

                      out.n(marko_node6, component);

                      out.n(marko_node7, component);

                      out.n(marko_node8, component);

                      out.ee();

                      out.be("div", marko_attrs4, "61", component);

                      out.be("h6", null, "62", component);

                      Locale_tag({
                          text: "Activities"
                        }, out, __component, "63");

                      out.ee();

                      out.be("div", marko_attrs5, "64", component);

                      Card_Activity_tag({
                          name: "C/C++ Language Program",
                          subject: "Evaluation course",
                          icon: "bx-sitemap",
                          link: "/programs/:id"
                        }, out, __component, "65");

                      Card_Activity_tag({
                          name: "Designer's Meeting",
                          status: "Started 4min ago",
                          icon: "bx-slideshow",
                          link: "/meetings/:id"
                        }, out, __component, "66");

                      Card_Activity_tag({
                          name: "Conversation on V8 Engine",
                          subject: "Forum Channel",
                          icon: "bx-conversation",
                          toggle: "chat:id"
                        }, out, __component, "67");

                      Card_Activity_tag({
                          name: "Knowledge Champion Game",
                          status: "5 Star reward",
                          icon: "bx-book-bookmark",
                          link: "/games/:id"
                        }, out, __component, "68");

                      out.ee();

                      out.ee();

                      out.ee();

                      out.ee();

                      out.ee();
                    }
                  }
              ]
          }, out, __component, "3");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
